import { useState, type FC } from 'react'
import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import { getLeadFieldValue } from '@pages/Admin/CRM/utils/leadFields'
import { Modal as AntdModal } from 'antd'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import type { LeadProfileLead } from '../../LeadProfileModal.types'
import classes from './deleteStudAccountModal.module.css'

interface HandlerDeleteStudAccountParams {
  lead: LeadProfileLead
  addAlert: (data: any) => void
  onSuccess: (payload: { detachParents: boolean }) => void
}

const DetachParentsCheckbox: FC<{
  onChange: (value: boolean) => void
}> = ({ onChange }) => {
  const [checked, setChecked] = useState(true)

  return (
    <CheckboxViolet
      text="Убрать родителей из карточки лида"
      value={checked}
      onClick={() => {
        const next = !checked
        setChecked(next)
        onChange(next)
      }}
      className={classes.checkbox}
      textClassName={classes.checkboxText}
      blockClassName={undefined}
    />
  )
}

export const handlerDeleteStudAccount = ({
  lead,
  addAlert,
  onSuccess,
}: HandlerDeleteStudAccountParams) => {
  const parentsCount = Array.isArray(lead.parents) ? lead.parents.length : 0
  const showDetachParentsCheckbox = parentsCount > 0
  /** Мутабельный стейт для Antd Modal.confirm (контент не пересоздаётся). */
  const state = { detachParents: true }

  AntdModal.confirm({
    title: 'Отвязать личный кабинет',
    content: (
      <div className={classes.content}>
        <div className={classes.leadName}>{getLeadFieldValue(lead, 'NAME')}</div>
        {showDetachParentsCheckbox ? (
          <div className={classes.detachParentsBlock}>
            <DetachParentsCheckbox
              onChange={(value) => {
                state.detachParents = value
              }}
            />
            <p className={classes.hint}>
              Родители остаются у ученика в ЛК в любом случае. Чекбокс решает
              только, останутся ли они в этом лиде.
            </p>
          </div>
        ) : null}
      </div>
    ),
    icon: null,
    centered: true,
    maskClosable: true,
    className: jclasses.modal,
    okText: 'Отвязать',
    cancelText: 'Отменить',
    okButtonProps: { danger: true },
    onOk: async () => {
      const detachParents = showDetachParentsCheckbox
        ? state.detachParents
        : true

      try {
        const res = await crmApi.deleteStudAccount({
          lead_id: lead?.id!,
          detach_parents: detachParents ? '1' : '0',
        })
        if (isError(res)) throw new Error()

        const data = res.data?.data
        addAlert({
          title: 'Успешно',
          text:
            data?.message ||
            'Личный кабинет ученика успешно отвязан от лида',
          type: 'success',
        })
        onSuccess({ detachParents })
      } catch {
        addAlert({
          title: 'Ошибка',
          text: 'Не удалось отвязать личный кабинет ученика',
          type: 'error',
        })
      }
    },
  })
}
